import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";
const clone = require("lodash/cloneDeep");

const state = {
  outfitter: {},
  displayGroups: [],
  external: false,
};

const getters = {
  getOutfitter: (state) => {
    return clone(state.outfitter);
  },
  getDisplayGroups: (state) => {
    return state.displayGroups;
  },
  stateIsExternal: (state) => {
    return state.external;
  },
  isExternal: () => {
    return localStorage.getItem("wwp-external") === "true" ? true : false;
  },
};

const actions = {
  async set_external({ commit }, external) {
    let value = external ? true : false;
    commit("set_external", value);
  },
  async clear_displayGroups({ commit }) {
    commit("clear_display_groups");
    return true;
  },
  async get_displayGroups({ commit }, data) {
    commit("clear_display_groups");
    const resp = await asyncHandler(
      HTTP({
        url: "search/displayGroups",
        method: "POST",
        data,
      })
    );
    if (resp.success) {
      commit("set_displayGroups", resp.displayGroups);
    }
    return resp;
  },
  async get_outfitter({ commit }, slug) {
    const resp = await asyncHandler(
      HTTP({
        url: "search/outfitter/" + slug,
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_outfitter", resp.outfitter);
    }
    return resp;
  },
};

const mutations = {
  set_outfitter: (state, outfitter) => {
    state.outfitter = outfitter;
  },
  set_displayGroups: (state, displayGroups) => {
    state.displayGroups = displayGroups;
  },
  clear_display_groups: (state) => {
    state.displayGroups = [];
  },
  set_external: (state, external) => {
    state.external = external;
    localStorage.setItem("wwp-external", external);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
